import {Controller} from '@hotwired/stimulus';

// ================================================
// == used to bind the click on the header-link
// == when the header is replaced with turbo
//   <%#= todo gwe 2026-12 replace this after upgraded to Turbo8 / turbo-rails 2.0
//   <%#= turbo_stream.dispatch "rebind:match-links" %>
// ================================================
export default class extends Controller {
  connect() {
    const link = this.element.parentElement?.querySelector('.match-link:not(.multi-match)')

    $(link).click(function(e){
      e.stopPropagation();
      match_two_col_clicks(e);
    });
    console.log("done")
  }
}